import { render, staticRenderFns } from "./SeedingBroadDrillSingleDetails.vue?vue&type=template&id=57b63786&scoped=true&"
import script from "./SeedingBroadDrillSingleDetails.vue?vue&type=script&lang=js&"
export * from "./SeedingBroadDrillSingleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b63786",
  null
  
)

export default component.exports